// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget-container[data-v-47506997]{position:relative}.widget-title[data-v-47506997]{height:40px;line-height:40px}.widget-title-immersive[data-v-47506997]{position:absolute;top:0;left:0;right:0;bottom:0}", ""]);
// Exports
module.exports = exports;
